export const environment = {
  production: false,
  url: "https://api-motor-encryptdecrypt.policystreet.app",
  googleTagId: "",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
  IsKeyManagementServiceEnabled: true,
  rsaPublicKeyBase64: "LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlHZU1BMEdDU3FHU0liM0RRRUJBUVVBQTRHTUFEQ0JpQUtCZ0doenk3WldrNncyTWRtYmZRQ0NSVHRMV2NvZQo3dzE4L3VOa0tTTUc4QzJneVVDYnY4YkhhdjNFbUlqU0hkYjhCd0wrZnl5cWdoWlZoc0RnaUw1Sk5BRU93aVl5Cm85RlF5R2ZDSXkxeE1LcDVFYXNkTEt3MndjakE0dGk3eUN6Qm9kczlQNTNETisrS3ZJYU96V1R1UjhPeUZFZVYKQmNGa2JDazdnUGhwcjc4SkFnTUJBQUU9Ci0tLS0tRU5EIFBVQkxJQyBLRVktLS0tLQ=="
};
